import { algolia_config } from './constants';
import General from './helpers/General';
import Observable from './helpers/Observable';
import { waitForWindowProperty } from './helpers/WaitForWindowProperty';

//constants
import { cookiesName } from './constants';

General.init();
General.bodyOverflowHiddenController();
// const sass_directory = 'sass2'
//
if (document.querySelector('#app')) {
  import(/* webpackChunkName: "app_main" */ './AppMainBoot');
}

if (document.querySelector('[data-header-section]')) {
  import(/* webpackChunkName: "modules_header-v2" */ './modules/HeaderV2');
}

let searchReady = null;
let searchAppLoaded = false;
let pendingSearchTrigger = null;

function loadSearchApp() {
  if (!document.querySelector('.search-module__container')) {
    return Promise.resolve();
  }

  if (!searchReady) {
    searchReady = import(
      /* webpackChunkName: "app_search" */ './apps-react/Search/components/Search/Search'
    )
      .then((module) => {
        const appReady = module?.searchAppReady || Promise.resolve();

        return appReady.then(() => {
          searchAppLoaded = true;
          document.removeEventListener('click', loadSearchOnIntent, true);
          return module;
        });
      })
      .catch((error) => {
        searchReady = null;
        throw error;
      });
  }

  return searchReady;
}

function loadSearchOnIntent(event) {
  const trigger = event.target?.closest?.('.header-main__search-toggle');

  if (!trigger || searchAppLoaded) {
    return;
  }

  event.preventDefault();
  event.stopImmediatePropagation();

  pendingSearchTrigger = trigger;
  loadSearchApp().then(() => {
    const nextTrigger = pendingSearchTrigger;
    pendingSearchTrigger = null;

    if (nextTrigger) {
      nextTrigger.click();
    }
  });
}

if (document.querySelector('.search-module__container')) {
  document.addEventListener('click', loadSearchOnIntent, true);
}

import LazySection from './LazySection';
import LazyAssets from './LazyAssets';
import Nav from './modules/Nav';
import CopyToClipboard from './modules/CopyToClipboard';
import Cookie from './helpers/Cookies';

// import Listrak from "./modules/external-systems/Listrak";
if (document.querySelector('.main-menu-mobile-nav')) {
  new Nav();
}
new CopyToClipboard();

import Stats from './helpers/Stats';
if (Stats) {
  Stats.listenerOnElements();
  Stats.eventsOnLoad();
}

// import Google from "./stats/modules/Google";
// Google.clickEvent();

if (window.trynowTest) {
  sessionStorage.setItem('trynowTest', true);
}

(async () => {
  sessionStorage.removeItem('document-lock');

  const observer = new Observable();
  const hasIntersectionObserver = Boolean(window.IntersectionObserver);

  const loadFeatureOnDemand = (
    selector,
    loader,
    { watchForNewNodes = false } = {}
  ) => {
    let ready = null;
    let mutationObserver = null;

    const load = () => {
      if (!ready) {
        ready = loader();
        mutationObserver?.disconnect();
      }
      return ready;
    };

    const observeTarget = (target) => {
      if (hasIntersectionObserver) {
        observer.subscribe(target, load);
      } else {
        load();
      }
    };

    const observeMatches = (root = document) => {
      const matches = [];

      if (root.matches?.(selector)) {
        matches.push(root);
      }

      root.querySelectorAll?.(selector).forEach((node) => {
        matches.push(node);
      });

      matches.forEach(observeTarget);
      return matches.length > 0;
    };

    const hasCurrentMatches = observeMatches();

    if (!hasCurrentMatches && !watchForNewNodes) {
      return;
    }

    if (watchForNewNodes && !ready) {
      if (!window.MutationObserver) {
        if (!hasCurrentMatches) {
          load();
        }
        return;
      }

      mutationObserver = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          mutation.addedNodes.forEach((node) => {
            observeMatches(node);
          });
        });
      });

      mutationObserver.observe(document.documentElement, {
        childList: true,
        subtree: true,
      });

      if (!hasCurrentMatches) {
        return;
      }
    }

    if (hasIntersectionObserver) {
      return;
    } else {
      load();
    }
  };
  // if (!window.IntersectionObserver) {
  // await import(/* webpackChunkName: "older_browsers" */ "./js_older-browsers");
  // } else {
  //     await import(/* webpackChunkName: "curently_browsers" */ "./js_curently-browsers");
  // }

  new LazySection(hasIntersectionObserver ? observer : false, Stats);
  const assets = new LazyAssets(hasIntersectionObserver ? observer : false);
  window.loadCssChunk = assets.loadCssChunk;

  if (hasIntersectionObserver) {
    const { default: LazyLoadImages } = await import(
      /* webpackChunkName: "modules_lazy-load-images" */ './modules/LazyLoadImages'
    );
    LazyLoadImages.listener();
    window.LazyLoaderRun = LazyLoadImages.listener;
  } else {
    const { default: LazyLoader } = await import(
      /* webpackChunkName: "modules-old-browsers_lazyLoader" */ `./modules-old-browsers/LazyLoader`
    );
    new LazyLoader();
  }

  if (algolia_config.active) {
    loadFeatureOnDemand('body', () =>
      import(
        /* webpackChunkName: "external_algolia" */ './modules/external-systems/Algolia'
      ).then(({ default: Algolia }) => {
        new Algolia();
      })
    );
  }

  if (window?.gld_dy?.enabled === true && window.gld_dy.event) {
    loadFeatureOnDemand(
      '.dy-api, .dy-custom-event--view, [data-dy-event-name]',
      () =>
        import(
          /* webpackChunkName: "external_dy" */ './modules/external-systems/DynamicYield'
        ).then(({ default: DynamicYield }) => {
          new DynamicYield(observer);
        })
    );
  }

  if (window.dyProductCardPerformance) {
    loadFeatureOnDemand('.product-card', () =>
      import(
        /* webpackChunkName: "modules_external-system_dy_product-card" */ './modules/external-systems/dynamic-yield/ProductCard'
      ).then(({ default: DYProductCard }) => {
        DYProductCard.getProductDataPerformance();
      })
    );
  }

  if (window.ab_test_discount) {
    import(
      /* webpackChunkName: "test_discount" */ './modules/tests/Discount'
    ).then(({ default: TestDiscount }) => {
      new TestDiscount(window.ab_test_discount);
    });
  }

  if (window.promotion_percentgage && window.promotion_percentgage > 0) {
    import(
      /* webpackChunkName: "test_promotions" */ './modules/tests/Promos'
    ).then(({ addPromos }) => {
      addPromos();
      window.addPromos = addPromos;

      const productCode = document.querySelector('.product-full__code');
      const productPromoData = document.querySelector('#product-promo-data');

      if (productCode && productPromoData?.dataset.isPromoProduct === 'true') {
        productCode.style.display = 'none';
      }
    });
  }

  loadFeatureOnDemand(
    '.v3-newsletter, [data-attentive-phone="true"], [data-attentive-submit="true"], .v3-attentive-form__form',
    () =>
      import(
        /* webpackChunkName: "external_attentive" */ './modules/external-systems/Attentive'
      ).then(({ Attentive }) => {
        Attentive();
      })
  );

  if (!window.GorgiasChat) {
    import(
      /* webpackChunkName: "external_gorgias" */ './modules/external-systems/Gorgias'
    ).then(({ default: Gorgias }) => {
      new Gorgias();
    });
  }

  if (window.promoBarTest) {
    import(
      /* webpackChunkName: "modules_test_sections" */ './modules/tests/Sections'
    ).then(({ default: AnnouncementBar }) => {
      new AnnouncementBar(
        '.shopify-section-gld_promotion-bar--big',
        '.promotion-bar',
        2
      );
    });
  }

  // if (window.productCardColorSwatchesTest) {
  //   const { default: ProductCardColorSwatches } = await import(
  //     /* webpackChunkName: "modules_test_color_swatches" */ "./modules/tests/ColorSwatches"
  //   );

  //   new ProductCardColorSwatches();
  // }

  const isPdpRedesignEligible = document.body.classList.contains(
    'pdp-redesign-eligible'
  );

  if (
    isPdpRedesignEligible &&
    (Cookie.get(cookiesName.ux.pdpRedesignTestActive) || window.PdpRedesignTest)
  ) {
    if (!Cookie.get(cookiesName.ux.pdpRedesignTestActive)) {
      Cookie.set({
        name: cookiesName.ux.pdpRedesignTestActive,
        value: true,
        expires: 1,
        path: '/',
      });
    }

    // Inline PdpRedesign logic
    if (window.productData) {
      document.body.classList.add('pdpRedesign-test-active');
    }
  }

  if (
    isPdpRedesignEligible &&
    (Cookie.get(cookiesName.ux.pdpRedesignGalleryTestActive) ||
      window.PdpRedesignGalleryTest)
  ) {
    if (!Cookie.get(cookiesName.ux.pdpRedesignGalleryTestActive)) {
      Cookie.set({
        name: cookiesName.ux.pdpRedesignGalleryTestActive,
        value: true,
        expires: 1,
        path: '/',
      });
    }

    // Inline PdpRedesignGallery logic
    if (window.productData) {
      document.body.classList.add('pdpRedesign-gallery-test-active');
    }
  }

  if (window.Shopify?.currency?.active === 'USD') {
    waitForWindowProperty('test_price').then((value) => {
      if (value !== undefined) {
        document.querySelector('body').classList.add('test-price');
      }
    });
  }

  if (
    window.show_scroll_progress &&
    document.getElementById('scrollProgressBar')
  ) {
    loadFeatureOnDemand('#scrollProgressBar', () =>
      import(
        /* webpackChunkName: "modules_ScrollProgressBar" */ './modules/ScrollProgressBar'
      ).then(({ default: ScrollProgressBar }) => {
        new ScrollProgressBar();
      })
    );
  }

  loadFeatureOnDemand(
    'localization-form',
    () =>
      import(
        /* webpackChunkName: "modules_LocalizationForm" */ './modules/LocalizationForm'
      ).then(({ default: LocalizationForm }) => {
        if (!customElements.get('localization-form')) {
          customElements.define('localization-form', LocalizationForm);
        }
      }),
    { watchForNewNodes: true }
  );

  loadFeatureOnDemand(
    '[data-svg]',
    () =>
      import(
        /* webpackChunkName: "modules_SvgFromUrlToCode" */ './modules/SvgFromUrlToCode'
      ).then(({ default: SvgFromUrlToCode }) => {
        SvgFromUrlToCode.init();
        window.SvgFromUrlToCodeRun = SvgFromUrlToCode.init;
      }),
    { watchForNewNodes: true }
  );

  waitForWindowProperty('DYO').then((value) => {
    import(
      /* webpackChunkName: "modules_external-system_dy_events" */ './modules/external-systems/dynamic-yield/Events'
    ).then(({ default: DyEvents }) => {
      new DyEvents({
        stats: Stats,
      });
    });
  });
})();

if (!window.showPreferences) {
  const footerLink = document.querySelector('.isense-reopen-widget-link');
  if (footerLink?.parentNode) {
    footerLink.parentNode.remove();
  }
}
